import {StyleSheet, Dimensions} from 'react-native';
import {Colors} from '../../constants/Colors';
const {height} = Dimensions.get('window');

export const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
  },
  modalContent: {
    flex: 1,
    backgroundColor: 'white',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    alignSelf: 'center',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingVertical: 15,
    width: '100%',
    paddingHorizontal: 20,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttonHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '60%',
    justifyContent: 'space-between',
  },
  containerIcon: {
    backgroundColor: Colors.lightGray,
    height: 40,
    width: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 50,
  },
  textHeader: {
    fontSize: 16,
    lineHeight: 19,
    fontFamily: 'TCCC-UnityText Bold',
    marginHorizontal: 10,
    marginRight: 20,
    color: Colors.GrayPallete.lightgrayThree,
  },
  iconX: {
    alignSelf: 'flex-end',
  },
  hello: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 22,
    color: Colors.RedPallete.red,
    marginTop: 20,
  },
  userName: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 22,
    color: Colors.RedPallete.red,
  },
  containerDrop: {
    marginTop: 30,
    borderTopWidth: 1,
    borderColor: Colors.lightGray,
  },
  spaceTop: {
    marginTop: 30,
  },
  buttonLogoff: {
    height: 70,
    justifyContent: 'center',
    marginBottom: 100,
  },
  logOffText: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightGrayFour,
    lineHeight: 18,
  },
  firstLabel: {
    marginTop: 6,
  },
  label: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.RedPallete.red,
  },
  value: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  saldoRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  saldoSkeletonBar: {
    width: 140,
    height: 16,
    borderRadius: 4,
    backgroundColor: Colors.lightGray,
  },
});
